// icon
import workScheduleIcon from "../assets/images/work-schedule/work-schedule-icon.svg";
import workPastScheduleIcon from "../assets/images/work-schedule/work-past-schedule-icon.svg";
import workDoneIcon from "../assets/images/work-schedule/work-done-icon.svg";
import workOverTimeIcon from "../assets/images/work-schedule/work-overtime-icon.svg";
import workPastOverTimeIcon from "../assets/images/work-schedule/work-past-overtime-icon.svg";
import workSpecialIcon from "../assets/images/work-schedule/work-special-icon.svg";
import workCommuteErrorIcon from "../assets/images/work-schedule/work-commute-error-icon.svg";
import workLateIcon from "../assets/images/work-schedule/work-late-icon.svg";
import workAbsenceIcon from "../assets/images/work-schedule/work-absence-icon.svg";
import workVacationIcon from "../assets/images/work-schedule/work-vacation-icon.svg";
import emptyScheduleCommuteIcon from "../assets/images/work-schedule/empty-schedule-commute-icon.svg";

export const WORK_SCHEDULE_EVENT = [
  {
    label: "근무예정",
    key: "schedule",
    icon: workScheduleIcon,
    isExpose: true,
  },
  {
    label: "근무예정(과거)",
    key: "pastSchedule",
    icon: workPastScheduleIcon,
    isExpose: false,
  },
  {
    label: "근무완료",
    key: "done",
    icon: workDoneIcon,
    isExpose: true,
  },
  {
    label: "출퇴근기록(근무예정 없음)",
    key: "emptySceduleCommute",
    icon: emptyScheduleCommuteIcon,
    isExpose: false,
  },
  {
    label: "연장근무",
    key: "overtime",
    icon: workOverTimeIcon,
    isExpose: true,
  },
  {
    label: "연장근무(과거)",
    key: "pastOvertime",
    icon: workPastOverTimeIcon,
    isExpose: false,
  },
  {
    label: "특별근무",
    key: "special",
    icon: workSpecialIcon,
    isExpose: true,
  },
  {
    label: "퇴근미입력",
    key: "commuteError",
    icon: workCommuteErrorIcon,
    isExpose: true,
  },
  {
    label: "지각, 조퇴",
    key: "late",
    icon: workLateIcon,
    isExpose: true,
  },
  {
    label: "결근",
    key: "absence",
    icon: workAbsenceIcon,
    isExpose: true,
  },
  {
    label: "휴가, 반차",
    key: "vacation",
    icon: workVacationIcon,
    isExpose: true,
  },
];
